module.exports = __webpack_public_path__ + "img/blue-jacket.94e3e82a.jpg";